<template>
    <div v-if="user" class="widget-wrap">
        <div class="widget welcome-widget">
            <div class="content">
                <template v-if="isOnboardingComplete">
                    <template v-if="isFromOldApp">
                        <h3>Welcome back, {{ user.name }}! We’re glad you’re here.</h3>
                        <p>Your Fusebox account is up to date. Before you dive in, watch this quick video from veteran podcaster and Fusebox co-founder, Pat Flynn. He’s nice!</p>
                    </template>
                    <template v-else>
                        <h3>Hi, {{ user.name }}! Welcome aboard.</h3>
                        <p>Your Fusebox account is ready to rock and roll. Before you dive in, watch this quick video from veteran podcaster and Fusebox co-founder, Pat Flynn. He’s nice!</p>
                    </template>
                </template>
                <template v-else>
                    <template v-if="isFromOldApp">
                        <h3>Hi, {{ user.name }}! Welcome back.</h3>
                        <p>Your Fusebox account now includes a spiffy profile section so that we can get to know you and your show better. Click below to get started!</p>
                    </template>
                    <template v-else>
                        <h3>Hi, {{ user.name }}! Welcome to Fusebox.</h3>
                        <p>Your account is ready to use but not quite complete! We’d still like to know more about you and your show. To finish your profile, click the button below. Thanks!</p>
                    </template>
                </template>
                <base-submit-button
                    class="btn"
                    @click="onButtonClick"
                >
                    {{ buttonLabel }}
                </base-submit-button>
            </div>

            <div
                v-if="isOnboardingComplete"
                class="video"
            >
                <base-wistia-loader
                    ref="video"
                    :video-id="'r6ftii6q2u'"
                    :height="226"
                    :width="424"
                />
            </div>
            <div
                v-else
                class="welcome-image"
            >
                <svg-vue icon="home-welcome" />
            </div>
        </div>
    </div>
</template>

<script>
import {
    mapState,
    mapMutations,
} from 'vuex';

export default {
    computed: {
        ...mapState(['user']),

        /**
         * @returns {boolean} Whether the onboarding has been finished.
         */
        isOnboardingComplete() {
            return !! this.user?.meta_data?.onboarding_finished;
        },

        /**
         * @returns {boolean} Whether the user comes from the old app.
         */
        isFromOldApp() {
            return this.user?.is_from_old_app;
        },

        /**
         * Returns button label based on onboarding status.
         *
         * @returns {string} Button label.
         */
        buttonLabel() {
            return this.isOnboardingComplete
                ? 'Watch Intro Video'
                : 'Let’s Get Started';
        },
    },

    methods: {
        ...mapMutations(['changeUIState']),

        /**
         * Handles button click.
         *
         * @returns {void}
         */
        onButtonClick() {
            if (this.isOnboardingComplete) {
                this.$refs.video.play();
            } else {
                this.changeUIState({ isOnboardingModalVisible: true });
            }
        },
    },
};
</script>
